<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {

  }
}
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  min-width: 1200px;
  min-height: 800px;
  background: url(./assets/bg.jpg) repeat;
  background-size: 100% 100%;
}
</style>
